export default __webpack_public_path__ + "static/media/logo.fc6d5153.png";